import {
  getSearchCombinations,
  getSelectedSuggestionAsArr,
  removeDuplicateSuggestions,
  deleteSearchSuggestionsByKey,
  getSearchText,
  getDocTypes,
  formAndSetCurrentSearchtDetail,
  setSearchParams,
  getTopicNotificationDates,
  resetTopicUrl,
  resetThemeXSearch,
} from './topicHelpers';
import {
  setShowBackdrop,
  setSuggestionsWithSelections,
  setSuggestions,
  setSuggestionsIsLoading,
  setSearchResults,
  setSearchResultHighlights,
  setSavedSearches,
  setCurrentSearchtDetail,
  setSelectedCompanyName,
  setOpenTopicSearchDialog,
  setTweetsData,
  setTweetsCountryMapData,
  setTweetsTableData,
  setTopicSearchCompany,
  setTwitterData,
  setTwitterMapData,
  setTwitterTimelineChartData,
  setTwitterTopEntityGridData,
  setTwitterTopEntityContext,
} from '../../reducers/Topic';
import axios from 'axios';
import { get, isEmpty, isArray, forEach, orderBy } from 'lodash';
import documentTypesData from '../../config/documentTypesData';
import moment from 'moment';
import { searchSuggestionTypeConfig } from '../../config/appConfig';
import { setSnackBarObj } from '../../reducers/Alerts';
import { setItemInLocalStorage, getSelectedRegionId } from 'utils/helpers';
import { dispatch } from 'config/store';
import { searchIndexs } from 'config/filterTypes';
import { extractItemsByUserPlan } from 'global/GlobalActions';
const anchorOrigin = { vertical: 'top', horizontal: 'center' };
const ERROR_MESSAGE = `We couldn't find any data matching your search criteria. Please try to refine your search and try again`;
const regionsObj = { '1': 'domestic', '2': 'global' };

let topicApiCallsCancelTokens = [];

export const performTopicSearchAggregate = (historyBy = 'month') => {
  return async (dispatch, getState) => {
    dispatch(setTopicSearchCompany(''));
    const searchIndex = getState().Topic.searchIndex;
    if (searchIndex['id'] === 4 || searchIndex['id'] === 5) {
      return;
    }
    setItemInLocalStorage('searchIndex', searchIndex);
    try {
      formAndSetCurrentSearchtDetail();
      const cancelTokenSource = axios.CancelToken.source();
      cancelTopicApiCalls();
      topicApiCallsCancelTokens.push(cancelTokenSource);
      dispatch(setShowBackdrop(true));
      const response = await axios.post(
        '/api/dictionary/search_aggregate',
        {
          ...createSearchPayload(getState().Topic),
          historyBy: historyBy,
        },
        { cancelToken: cancelTokenSource.token }
      );
      let newSearchResults = get(response, 'data', null);
      if (get(newSearchResults, 'count', false)) {
        const results = get(newSearchResults, 'buckets.groupByCompanyTicker', []);
        if (results.length) {
          const latestDocumentCompany = results[0];
          const { cName, ct, cid } = latestDocumentCompany.key;
          dispatch(performTopicSearchHighlights(cName, ct, cid));
        }
        dispatch(setSearchResults(newSearchResults));
      } else {
        resetTopicUrl();
        dispatch(setSnackBarObj({ severity: 'error', message: ERROR_MESSAGE }));
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.log(error);
        resetTopicUrl();
      }
    } finally {
      dispatch(setShowBackdrop(false));
    }
  };
};

export const performTopicSearchHighlights = (companyName = null, ticker, companyId) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setShowBackdrop(true));
      const cancelTokenSource = axios.CancelToken.source();
      cancelTopicApiCalls();
      topicApiCallsCancelTokens.push(cancelTokenSource);
      const { data: resData } = await axios.post(
        '/api/dictionary/search_highlights_by_index',
        {
          ...createSearchPayload({ ...getState().Topic }, companyName),
          ticker,
          companyId,
          selected_region: getSelectedRegionId(regionsObj[getState().Topic.searchIndex?.id]),
        },
        { cancelToken: cancelTokenSource.token }
      );
      if (resData?.highlights?.length) {
        const companyInfo = {
          companyName,
          ticker,
          companyId,
          isTickerActive: resData.isTickerActive,
          industry: get(resData, 'industry', ''),
          sector: get(resData, 'sector', ''),
          flag: resData.source_social_id,
        };
        dispatch(setSelectedCompanyName(companyName));
        // const highlightResults = uniqBy(resData.highlights, 'summary_id');
        dispatch(setSearchResultHighlights({ companyInfo, highlightResults: resData.highlights }));
      } else {
        dispatch(setSearchResultHighlights(null));
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.log(error);
        dispatch(setSearchResultHighlights(null));
      }
    } finally {
      resetTopicUrl();
      dispatch(setShowBackdrop(false));
    }
  };
};

const createSearchPayload = (topicState, companyName = null) => {
  const topicNotificationDates = getTopicNotificationDates();
  const { onlySuggestionSingleArr } = getSelectedSuggestionAsArr(topicState.selectedSuggestions, topicState.searchText);

  return {
    searchTerm: getSearchText(
      topicState.simpleSearchTextArray,
      topicState.ignoreSearchTextArray,
      topicState.searchTextWithAnd,
      onlySuggestionSingleArr,
      topicState.searchText,
      topicState.isSimpleSearch
    ),
    startDate: topicNotificationDates ? undefined : moment(topicState.startDate).format('YYYY-MM-DD HH:mm:ss'),
    endDate: topicNotificationDates ? undefined : moment(topicState.endDate).format('YYYY-MM-DD HH:mm:ss'),
    document_types: getDocTypes(topicState.selectedDocumentTypes, documentTypesData),
    orderBy: 'desc',
    sortBy: 'document_date',
    page: 0,
    company_arr: companyName
      ? [companyName]
      : topicState.selectedWatchlistCompanyNames.length
      ? topicState.selectedWatchlistCompanyNames.map(c => c.companyName)
      : undefined,
    sector: topicState.selectedSector ? topicState.selectedSector : undefined,
    industry_arr: topicState.selectedIndustries.length !== 0 ? topicState.selectedIndustries : undefined,
    searchIndex: topicState.searchIndex['value'],
    startTime: topicNotificationDates ? topicNotificationDates.urlStartTime : undefined,
    endTime: topicNotificationDates ? topicNotificationDates.urlEndTime : undefined,
    countryCode: topicState.selectedCountry ? topicState.selectedCountry['code'] : undefined,
    watchlist_group_id:
      topicState.selectedUniverse === 'watchlist' && topicState.selectedWatchlistCategory
        ? topicState.selectedWatchlistCategory
        : undefined,
  };
};

export const fetchTopicsList = (makeFreshCall = false, setSearchInRedux) => {
  return async (dispatch, getState) => {
    const savedSearches = getState().Topic.savedSearches;
    if (savedSearches?.length && makeFreshCall === false) return savedSearches;
    const response = await axios.get('/api/search/list_searches');
    const allSearches = response.data?.data ?? [];

    const allowedSearchIndexs = extractItemsByUserPlan(null, searchIndexs);

    let savedSearchs = [];

    allSearches.forEach(search => {
      const savedIndex = search.searchJSON.searchIndex;
      const matchedIndex = allowedSearchIndexs.find(allowedSearchIndex => allowedSearchIndex.value === savedIndex);
      if (matchedIndex) {
        search.searchJSON.searchIndex = matchedIndex;
        savedSearchs.push(search);
      }
    });

    // in the bellow 'if' all the document types will be removed that are coming from backend but are deleted from frontend documentTypesData
    if (savedSearchs.length) {
      let docValuesWithGrp = {};
      documentTypesData.forEach(doc => {
        doc.value.forEach(singleValue => {
          docValuesWithGrp[`${singleValue.value.toLowerCase()}`] = doc.documentTypeGroup;
        });
      });
      savedSearchs.forEach(singleSearch => {
        const singleSearchDocTypes = [];
        if (singleSearch.searchJSON?.selectedDocumentTypes?.length) {
          singleSearch.searchJSON.selectedDocumentTypes.forEach(userSelectedDoc => {
            const userDocGroup = docValuesWithGrp[userSelectedDoc.toLowerCase()];
            if (userDocGroup && singleSearchDocTypes.indexOf(userDocGroup) === -1) {
              singleSearchDocTypes.push(userDocGroup);
            }
          });
        }
        if (singleSearchDocTypes.length) {
          singleSearch.searchJSON.selectedDocumentTypes = singleSearchDocTypes;
        } else {
          singleSearch.searchJSON.selectedDocumentTypes = documentTypesData.map(doc => doc.documentTypeGroup);
        }
      });

      const sortedSearches = orderBy(savedSearchs, [search => search.searchLabel.toLowerCase()], ['asc']);
      switch (setSearchInRedux) {
        case 'firstSorted':
          setSearchParams(sortedSearches[0]);
          break;
        case 'latestSearch':
          setSearchParams(savedSearchs[savedSearchs.length - 1]);
          break;
        default:
          break;
      }
      dispatch(setSavedSearches(sortedSearches));
      return sortedSearches;
    } else {
      dispatch(setSavedSearches([]));
      dispatch(setOpenTopicSearchDialog(true));
      dispatch(setCurrentSearchtDetail({}));
    }
  };
};

const createSearchSaveMiniPayload = topicState => {
  const { suggestionsArr, suggestionsSingleArr, onlySuggestionSingleArr } = getSelectedSuggestionAsArr(
    topicState.selectedSuggestions,
    topicState.searchText
  );
  const fullSearchText = suggestionsSingleArr.length ? getSearchCombinations(suggestionsArr) : topicState.searchText;
  return {
    selectedSuggestions: topicState.selectedSuggestions,
    searchedText: getSearchText(
      topicState.simpleSearchTextArray,
      topicState.ignoreSearchTextArray,
      topicState.searchTextWithAnd,
      onlySuggestionSingleArr,
      topicState.searchText,
      topicState.isSimpleSearch
    ),
    selectedDocumentTypes: getDocTypes(topicState.selectedDocumentTypes, documentTypesData),
    searchTerm: fullSearchText,
    sector: topicState.selectedSector ? topicState.selectedSector : undefined,
    universe: topicState.selectedUniverse,
    selectedWatchlistCategory:
      topicState.selectedUniverse === 'watchlist' ? topicState.selectedWatchlistCategory : null,
    searchTextWithAnd: !topicState.isSimpleSearch ? [] : topicState.searchTextWithAnd,
    simpleSearchTextArray: !topicState.isSimpleSearch ? [] : topicState.simpleSearchTextArray,
    ignoreSearchTextArray: !topicState.isSimpleSearch ? [] : topicState.ignoreSearchTextArray,
    isSimpleSearch: topicState.isSimpleSearch,
    company_arr: topicState.selectedWatchlistCompanyNames,
    searchIndex: topicState.searchIndex.value,
    countryCode: topicState.selectedCountry ? topicState.selectedCountry : undefined,
  };
};

export const handleSaveSearch = () => {
  return async (dispatch, getState) => {
    const { searchText, isTopicEmailAlertEnable, searchLabel, searchIndex } = getState().Topic;
    const payload = {
      searchText: searchText,
      searchJSON: createSearchSaveMiniPayload(getState().Topic),
      // email alert false for Twitter Firehose
      send_topic_alert_email: searchIndex['id'] === 5 ? false : isTopicEmailAlertEnable,
      searchLabel: searchLabel,
    };

    try {
      const response = await axios.post('/api/search/save_search', payload);
      const responsePayload = get(response, 'data', null);
      if (responsePayload) {
        setItemInLocalStorage('searchIndex', searchIndex);
        dispatch(fetchTopicsList(true, 'latestSearch'));
        dispatch(setSnackBarObj({ severity: 'success', message: 'Search Saved successfully', anchorOrigin }));
      } else {
        dispatch(setSnackBarObj({ severity: 'error', anchorOrigin }));
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateSaveSearch = searchId => {
  return async (dispatch, getState) => {
    const { searchText, searchLabel, isTopicEmailAlertEnable, searchIndex } = getState().Topic;
    const payload = {
      searchText: searchText,
      searchLabel: searchLabel,
      searchJSON: createSearchSaveMiniPayload(getState().Topic),
      // email alert false for Twitter Firehose
      send_topic_alert_email: searchIndex['id'] === 5 ? false : isTopicEmailAlertEnable,
    };

    try {
      const response = await axios.put(`/api/search/update_search/${searchId}`, payload);
      const isSuccess = get(response, 'data.data', null);
      if (isSuccess) {
        dispatch(fetchTopicsList(true, null));
        dispatch(setSnackBarObj({ severity: 'success', message: 'Search updated successfully', anchorOrigin }));
      } else {
        dispatch(setSnackBarObj({ severity: 'error', message: 'Search Saved successfully', anchorOrigin }));
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const deleteSearch = searchId => {
  return async (dispatch, getState) => {
    const selectedSearchId = getState().Topic.selectedSearch?.searchId;
    const savedSearches = getState().Topic.savedSearches;
    const response = await axios.delete(`/api/search/delete_search/${searchId}`);
    const isDeleted = get(response, 'data.data.status', false);
    if (isDeleted) {
      const searchesAfterDelete = savedSearches.filter(s => s.searchId !== searchId);
      dispatch(setSavedSearches(searchesAfterDelete));
      if (selectedSearchId === searchId) {
        resetThemeXSearch();
      }
      dispatch(setSnackBarObj({ severity: 'success', message: 'Search Deleted successfully', anchorOrigin }));
    } else {
      dispatch(setSnackBarObj({ severity: 'error', anchorOrigin }));
    }
  };
};

export const findSuggestions = () => {
  return async (dispatch, getState) => {
    const {
      searchText,
      selectedSuggestions,
      isSimpleSearch,
      simpleSearchTextArray,
      searchSuggestionType,
      searchTextWithAnd,
      ignoreSearchTextArray,
    } = getState().Topic;

    let simpleSearchArray = [];

    if (searchSuggestionType === searchSuggestionTypeConfig.searchTextWithAnd) {
      simpleSearchArray = searchTextWithAnd;
    } else if (searchSuggestionType === searchSuggestionTypeConfig.ignoreSearchTextArray) {
      simpleSearchArray = ignoreSearchTextArray;
    } else {
      simpleSearchArray = simpleSearchTextArray;
    }

    let searchSug = '';

    if (isSimpleSearch) {
      searchSug = simpleSearchArray.length > 0 ? simpleSearchArray.join(',') : [];
    } else {
      const regex = /\b(and|or|not)\b/gi;
      const removeSpacesRegex = /\s{2,}/g;
      searchSug = searchText
        .replace(regex, '')
        .replace(removeSpacesRegex, ' ')
        .split(' ')
        .join(',');
    }
    if (!searchSug) {
      return;
    }
    dispatch(setSuggestionsIsLoading(true));
    dispatch(setSuggestions({}));
    try {
      const response = await axios.post('/api/dictionary/search', { searchTerm: searchSug });
      const responsePayload = get(response, 'data', null);
      let rawSuggestions = get(responsePayload, 'results', {});
      if (isArray(rawSuggestions) && rawSuggestions.length === 0) {
        rawSuggestions = {};
      }

      // remove duplicated from suggestions
      let deleteValues = isSimpleSearch ? simpleSearchArray : searchText;
      let deleteKeys = ['or', 'OR', 'and', 'and/or'];
      let newSuggestions = deleteSearchSuggestionsByKey(
        removeDuplicateSuggestions(rawSuggestions),
        deleteKeys,
        deleteValues
      );

      let filterNewSuggestions = {};

      forEach(newSuggestions, (v, k) => {
        let filteredData = v.filter(
          item =>
            item.indexOf('https') === -1 &&
            item.indexOf(')') === -1 &&
            item.indexOf('#') === -1 &&
            item.indexOf('http') === -1
        );

        filterNewSuggestions[k] = filteredData.length > 0 ? filteredData : [];
      });

      let newSelectedSuggestions = {};
      if (isEmpty(selectedSuggestions)) {
        let oneValueArray = [];
        forEach(filterNewSuggestions, (values, keyWord) => {
          if (values.length > 0) {
            newSelectedSuggestions[keyWord] = [];
          } else {
            delete filterNewSuggestions[keyWord];
          }
          if (values.length === 1) {
            oneValueArray.push(values[0]);
            delete filterNewSuggestions[keyWord];
          }
        });
        if (oneValueArray.length > 0) {
          filterNewSuggestions['May be of interest'] = oneValueArray;
          newSelectedSuggestions['May be of interest'] = [];
        }

        dispatch(setSuggestionsWithSelections(filterNewSuggestions, newSelectedSuggestions));
      } else {
        let oneValueArray = [];
        forEach(filterNewSuggestions, (values, keyWord) => {
          if (values.length === 0) {
            delete filterNewSuggestions[keyWord];
          }
          if (values.length === 1) {
            oneValueArray.push(values[0]);
            delete filterNewSuggestions[keyWord];
          }
        });
        if (oneValueArray.length > 0) {
          filterNewSuggestions['May be of interest'] = oneValueArray;
        }

        dispatch(setSuggestions(filterNewSuggestions));
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setSuggestionsIsLoading(false));
    }
  };
};

export const getFormattedTweetsDataInBulk = responseData => {
  if (!responseData || !responseData.data || !responseData.includes) {
    return null;
  }

  const entitiesCount = {};
  const { data: tweetsData, includes } = responseData;
  const { media = [], users = [], places = [] } = includes;

  const dataValues = tweetsData.map(tweet => {
    const { id, author_id, created_at, attachments, geo, text, context_annotations } = tweet;

    if (context_annotations) {
      context_annotations.forEach(s => {
        const domainId = s.domain.id;
        const entityId = s.entity.id;
        const entityName = s.entity.name;

        if (entitiesCount[entityName] === undefined) {
          entitiesCount[entityName] = {};
        }

        entitiesCount[entityName].count = (entitiesCount[entityName].count ?? 0) + 1;
        entitiesCount[entityName].domainId = domainId;
        entitiesCount[entityName].entityId = entityId;
      });
    }

    const user = users.find(user => user.id === author_id);

    if (!id || !user) {
      return null;
    }

    const { name: user_display_name, username: user_account_name, profile_image_url } = user;

    const media_keys = attachments?.media_keys ?? [];
    const mediaArr = media
      .filter(media_item => media_keys.includes(media_item.media_key))
      .map(media_item => ({
        media_url_https: media_item.type === 'video' ? media_item.preview_image_url : media_item.url,
        type: media_item.type,
      }));

    return {
      id_str: id ?? null,
      user: {
        id: author_id,
        name: user_display_name,
        screen_name: user_account_name,
        profile_image_url,
      },
      created_at: created_at ? new Date(created_at) : null,
      media: mediaArr,
      country_code: places.find(place => place.id === geo?.place_id)?.country_code,
      text,
    };
  });

  const countryCount = {};
  places.forEach(place => {
    const countryCode = place.country_code.toLowerCase();
    countryCount[countryCode] = (countryCount[countryCode] ?? 0) + 1;
  });

  let totalCountryCount = 0;
  Object.values(countryCount).forEach(value => {
    totalCountryCount = totalCountryCount + value;
  });
  if (dataValues.length > totalCountryCount) {
    countryCount['N/A'] = dataValues.length - totalCountryCount;
  }

  const tweetTopEntities = [];
  if (Object.keys(entitiesCount).length) {
    forEach(entitiesCount, (entityValue, entitiesName) => {
      tweetTopEntities.push({ entitiesName, ...entityValue });
    });
  }

  return { data: dataValues, countryCount, tweetTopEntities };
};

export const makeTweetDataReadyToBeFormatted = tweetsData => {
  const tweetData = [];
  const mediaData = [];
  const usersData = [];
  const placesData = [];

  tweetsData.forEach(tweet => {
    const { tweet_json: tweetJson } = tweet;
    const { data, includes } = tweetJson;
    const { media = [], users = [], places = [] } = includes;

    tweetData.push(data);
    mediaData.push(...media);
    usersData.push(...users);
    placesData.push(...places);
  });

  const includes = { media: mediaData, users: usersData, places: placesData };

  return { data: tweetData, includes };
};

export const performTopicTweetsSearchAggregate = (companyInfo = null, domainId = null, entityId = null) => {
  return async (dispatch, getState) => {
    const searchIndex = getState().Topic.searchIndex['id'];
    if (![4, 5].includes(searchIndex)) return;

    try {
      dispatch(setShowBackdrop(true));
      cancelTopicApiCalls();
      const cancelTokenSource = axios.CancelToken.source();
      topicApiCallsCancelTokens.push(cancelTokenSource);
      formAndSetCurrentSearchtDetail();
      let requestPayload = null;

      if (searchIndex === 4) {
        requestPayload = {
          ...createSearchPayloadTweets(getState().Topic, domainId, entityId),
          ticker: companyInfo?.ticker,
        };
        const response = await axios.post('/api/dictionary/search_tweets_data', requestPayload, {
          cancelToken: cancelTokenSource.token,
        });
        const newSearchResults = get(response, 'data', null);
        if (newSearchResults?.data?.length) {
          const tweetDataReadyToBeFormatted = makeTweetDataReadyToBeFormatted(newSearchResults.data);
          const formattedTweetData = getFormattedTweetsDataInBulk(tweetDataReadyToBeFormatted);

          if (companyInfo) {
            companyInfo.isTickerActive = newSearchResults.isTickerActive;
            companyInfo.flag = newSearchResults.source_social_id;
          } else {
            dispatch(setTweetsTableData(newSearchResults.buckets?.topicNames ?? []));
          }
          dispatch(setTweetsData({ companyInfo, data: formattedTweetData.data }));
          dispatch(setTwitterTopEntityGridData(formattedTweetData.tweetTopEntities));
        } else {
          dispatch(setSnackBarObj({ severity: 'error', message: ERROR_MESSAGE }));
        }
      }

      if (searchIndex === 5) {
        requestPayload = { ...createSearchPayloadTwitter(getState().Topic, domainId, entityId) };
        const response = await axios.post('/api/dictionary/search_twitter_data', requestPayload, {
          cancelToken: cancelTokenSource.token,
        });
        const newSearchResults = response.data?.data ?? {};

        const formattedTwitterData = getFormattedTweetsDataInBulk(newSearchResults);
        if (formattedTwitterData?.data?.length) {
          dispatch(setTwitterData(formattedTwitterData.data));
          dispatch(setTwitterTopEntityGridData(formattedTwitterData.tweetTopEntities));
          dispatch(setTwitterMapData(Object.entries(formattedTwitterData.countryCount)));
        } else {
          const errorMessage = newSearchResults?.errors[0]?.message ?? ERROR_MESSAGE;
          dispatch(setSnackBarObj({ severity: 'error', message: errorMessage }));
          dispatch(setTwitterData([]));
        }
      }

      if (requestPayload) {
        await getTwitterTimelineData(requestPayload);
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.log(error);
      }
    } finally {
      dispatch(setShowBackdrop(false));
    }
  };
};

export const getTwitterTimelineData = async timelineRequestPayload => {
  try {
    const cancelTokenSource = axios.CancelToken.source();
    topicApiCallsCancelTokens.push(cancelTokenSource);
    const response = await axios.post('/api/dictionary/search_twitter_timeline_data', timelineRequestPayload, {
      cancelToken: cancelTokenSource.token,
    });
    dispatch(setTwitterTimelineChartData(response.data.data || []));
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.error(error);
    }
  }
};

const createSearchPayloadTweets = (topicState, domainId, entityId) => {
  const { onlySuggestionSingleArr } = getSelectedSuggestionAsArr(topicState.selectedSuggestions, topicState.searchText);
  let searchTerm = getSearchText(
    topicState.simpleSearchTextArray,
    topicState.ignoreSearchTextArray,
    topicState.searchTextWithAnd,
    onlySuggestionSingleArr,
    topicState.searchText,
    topicState.isSimpleSearch
  );

  if (domainId && entityId) {
    const topEntityContext = concatCurrentContextWithPrevious(topicState.twitterTopEntityContext, domainId, entityId);
    searchTerm = `${searchTerm} ${topEntityContext}`;
  }

  return {
    searchTerm: searchTerm,
    page: 0,
    searchIndex: topicState.searchIndex['value'],
  };
};

export const getMapDataByCountry = country => {
  return async dispatch => {
    try {
      const response = await axios.get(
        `https://code.highcharts.com/mapdata/countries/${country}/${country}-all.geo.json`
      );

      const data = get(response, 'data', {});
      if (response) {
        dispatch(setTweetsCountryMapData(data));
      } else {
        dispatch(setTweetsCountryMapData({}));
      }
    } catch (error) {
      dispatch(setTweetsCountryMapData({}));
    }
  };
};

const createSearchPayloadTwitter = (topicState, domainId, entityId) => {
  const { onlySuggestionSingleArr } = getSelectedSuggestionAsArr(topicState.selectedSuggestions, topicState.searchText);
  const currentTimeMinusOneMinute = moment()
    .subtract(1, 'minutes')
    .utc();
  const startDate = moment(topicState.startDate).isValid()
    ? moment(topicState.startDate)
    : moment().subtract(12, 'months');
  let endDate = moment(topicState.endDate).isValid() ? moment(topicState.endDate) : currentTimeMinusOneMinute;

  // twitter api allow only current-date for end-date
  endDate = endDate.isBefore(new Date()) ? endDate : currentTimeMinusOneMinute;
  let searchTerm = topicState.simpleSearchTextArray.length
    ? `(${topicState.simpleSearchTextArray.map(item => `"${item}"`).join(' OR ')})`
    : '';
  searchTerm = searchTerm.trimEnd() + ' ' + topicState.searchTextWithAnd.map(item => `"${item}"`).join(' ');
  searchTerm = searchTerm.trimEnd() + ' ' + topicState.ignoreSearchTextArray.map(item => `-"${item}"`).join(' ');
  if (topicState.selectedCountry) {
    searchTerm = searchTerm.trimEnd() + ' place_country:' + topicState.selectedCountry.code;
  }

  if (!topicState.isSimpleSearch) {
    const suggestions = onlySuggestionSingleArr.length
      ? `(${onlySuggestionSingleArr.map(item => `"${item}"`).join(' OR ')})`
      : '';
    searchTerm = `${topicState.searchText} ${suggestions}`;
    searchTerm = searchTerm.replace(/\s+(AND)?\s+/g, ' ').trim();
  }
  if (topicState.twitterGeoLocationEnable) {
    searchTerm = searchTerm + ' has:geo';
  }
  searchTerm = searchTerm.trim().concat(' -is:retweet');

  if (domainId && entityId) {
    const topEntityContext = concatCurrentContextWithPrevious(topicState.twitterTopEntityContext, domainId, entityId);
    searchTerm = `${searchTerm} ${topEntityContext}`;
  }

  const data = {
    searchTerm: searchTerm,
    startDate: startDate.format('yyyy-MM-DD HH:mm:ss'),
    endDate: endDate.format('yyyy-MM-DD HH:mm:ss'),
    maxResults: 99,
  };
  return data;
};

const concatCurrentContextWithPrevious = (twitterTopEntityContext, domainId, entityId) => {
  const topEntityContext = `${twitterTopEntityContext} context:${domainId}.${entityId}`;
  dispatch(setTwitterTopEntityContext(topEntityContext));
  return topEntityContext;
};

export const cancelTopicApiCalls = () => {
  topicApiCallsCancelTokens.forEach(token => {
    token.cancel();
  });
  topicApiCallsCancelTokens = [];
};
